import { LegalDoc } from "@/components/LegalDoc";

const SECTIONS = [
  {
    title: "Titolare del trattamento",
    blocks: [
      { p: "La presente informativa è resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (\"GDPR\") agli utenti del sito del Professor Carlo Enrico Traverso." },
      { p: "Il Titolare del trattamento è:" },
      {
        fields: [
          { k: "Titolare", v: "Professor Carlo Enrico Traverso" },
          { k: "Indirizzo", v: "Largo XII Ottobre 62, 16121 Genova (GE)" },
          { k: "Codice Fiscale", v: "TRVCRL54P30I480I" },
          { k: "Partita IVA", v: "02979950991" },
          { k: "Email", v: "mc8620@mclink.it", href: "mailto:mc8620@mclink.it" },
          { k: "PEC", v: "carlo.traverso.ZKE7@sv.omceo.it", href: "mailto:carlo.traverso.ZKE7@sv.omceo.it" },
        ],
      },
    ],
  },
  {
    title: "Dati personali trattati",
    blocks: [
      { p: "Durante la normale navigazione sul sito possono essere trattati alcuni dati tecnici necessari al corretto funzionamento e alla sicurezza del servizio, quali indirizzo IP, informazioni relative al browser e al dispositivo utilizzato e dati tecnici connessi alle richieste effettuate al server." },
      { p: "Attraverso il modulo \"Richiedi una valutazione\" possono essere raccolti:" },
      {
        list: [
          "nome;",
          "cognome;",
          "numero di cellulare;",
          "indirizzo email;",
          "territorio di interesse, Genova o Savona;",
          "tipologia di richiesta, Visita o Chirurgia;",
          "informazioni liberamente inserite dall'utente nel campo \"Descrivi brevemente la tua esigenza\".",
        ],
      },
      { p: "Le informazioni inserite liberamente dall'utente possono, in alcuni casi, contenere o permettere di desumere informazioni relative al suo stato di salute e rientrare quindi nelle categorie particolari di dati personali previste dall'art. 9 del GDPR." },
    ],
  },
  {
    title: "Finalità del trattamento",
    blocks: [
      { p: "I dati forniti attraverso il modulo \"Richiedi una valutazione\" vengono trattati esclusivamente per:" },
      {
        list: [
          "ricevere e gestire la richiesta dell'utente;",
          "consentire alla segreteria di ricontattare l'interessato;",
          "fornire informazioni relative alla visita o all'attività chirurgica richiesta;",
          "gestire l'eventuale successiva prenotazione.",
        ],
      },
      { p: "I dati non vengono utilizzati per:" },
      {
        list: [
          "marketing;",
          "newsletter;",
          "profilazione;",
          "pubblicità;",
          "comunicazioni commerciali;",
          "analisi automatizzate del comportamento dell'utente.",
        ],
      },
    ],
  },
  {
    title: "Base giuridica del trattamento",
    blocks: [
      { p: "Per i dati personali comuni forniti attraverso il modulo, il trattamento è effettuato per dare seguito alla richiesta dell'interessato e per l'esecuzione di misure precontrattuali adottate su richiesta dello stesso, ai sensi dell'art. 6, par. 1, lett. b) del GDPR." },
      { p: "Qualora le informazioni liberamente inserite dall'utente contengano o consentano di desumere dati relativi alla salute, il relativo trattamento viene effettuato sulla base del consenso esplicito dell'interessato, ai sensi dell'art. 9, par. 2, lett. a) del GDPR." },
      { p: "Il consenso eventualmente prestato può essere revocato in qualsiasi momento, senza pregiudicare la liceità del trattamento effettuato prima della revoca." },
      { p: "Gli eventuali successivi trattamenti effettuati nell'ambito di una concreta prestazione sanitaria e del rapporto medico-paziente saranno disciplinati dalla normativa applicabile ai trattamenti sanitari e dalle relative informative." },
    ],
  },
  {
    title: "Natura del conferimento",
    blocks: [
      { p: "Il conferimento dei dati indicati come obbligatori nel modulo è necessario per consentire alla segreteria di gestire la richiesta e ricontattare l'interessato." },
      { p: "La mancata compilazione dei campi obbligatori impedisce l'invio della richiesta." },
      { p: "Prima dell'invio del modulo l'utente deve:" },
      {
        list: [
          "dichiarare di aver preso visione dell'Informativa Privacy;",
          "prestare, ove necessario, il proprio consenso esplicito al trattamento delle informazioni relative alla salute eventualmente contenute nel modulo.",
        ],
      },
    ],
  },
  {
    title: "Modalità del trattamento",
    blocks: [
      { p: "I dati personali sono trattati con strumenti informatici e telematici e mediante l'adozione di misure tecniche e organizzative adeguate alla natura dei dati trattati." },
      { p: "Le richieste inviate attraverso il modulo non vengono archiviate in un database del sito." },
      { p: "Il sito non utilizza sistemi di profilazione, analytics comportamentali o session recording." },
    ],
  },
  {
    title: "Destinatari dei dati",
    blocks: [
      { p: "Le richieste effettuate attraverso il modulo vengono trasmesse esclusivamente alla segreteria operativa incaricata di gestire il ricontatto e l'eventuale prenotazione del paziente." },
      { p: "L'indirizzo operativo destinatario delle richieste è:" },
      { fields: [{ k: "Destinatario", v: "e.gallino@cds.it", href: "mailto:e.gallino@cds.it" }] },
      { p: "La segreteria ricontatta l'interessato utilizzando i recapiti indicati nel modulo." },
      { p: "Qualora il paziente decida successivamente di effettuare una prenotazione presso Casa della Salute, i dati necessari alla prenotazione verranno trattati dalla struttura secondo la propria organizzazione e le proprie informative privacy." },
      { p: "Potranno inoltre essere coinvolti, nei limiti strettamente necessari al funzionamento tecnico del servizio, fornitori di servizi di hosting, sicurezza informatica e trasmissione email." },
      { p: "I dati non vengono comunicati a MedPartner S.r.l. attraverso il modulo \"Richiedi una valutazione\"." },
      { p: "I dati non vengono ceduti a terzi per finalità commerciali." },
    ],
  },
  {
    title: "Conservazione dei dati",
    blocks: [
      { p: "Le richieste ricevute attraverso il modulo e conservate nella casella email della segreteria vengono mantenute per un periodo massimo di 12 mesi dalla loro ricezione, salvo che sia necessaria una conservazione ulteriore per adempiere a obblighi di legge, tutelare un diritto o gestire un rapporto successivamente instaurato con l'interessato." },
      { p: "Qualora dalla richiesta derivi una prenotazione o una prestazione sanitaria, gli ulteriori dati trattati nell'ambito di tale rapporto seguiranno i differenti termini di conservazione applicabili alla struttura sanitaria e alla documentazione sanitaria." },
    ],
  },
  {
    title: "Trasferimenti extra SEE",
    blocks: [
      { p: "Alcuni fornitori tecnici utilizzati per la sicurezza, l'hosting o il funzionamento del sito potrebbero, in base alla propria infrastruttura, effettuare trattamenti di dati tecnici anche al di fuori dello Spazio Economico Europeo." },
      { p: "Eventuali trasferimenti internazionali di dati personali vengono effettuati nel rispetto delle condizioni e delle garanzie previste dal GDPR." },
    ],
  },
  {
    title: "Diritti dell'interessato",
    blocks: [
      { p: "L'interessato può esercitare, nei casi previsti dalla normativa, i diritti riconosciuti dagli artt. 15-22 del GDPR, tra cui:" },
      {
        list: [
          "accesso ai propri dati personali;",
          "rettifica dei dati inesatti;",
          "cancellazione;",
          "limitazione del trattamento;",
          "opposizione nei casi previsti;",
          "portabilità dei dati, ove applicabile.",
        ],
      },
      { p: "Quando il trattamento dei dati relativi alla salute è basato sul consenso, l'interessato può inoltre revocare tale consenso in qualsiasi momento." },
      { p: "Le richieste possono essere inviate a:" },
      {
        fields: [
          { k: "Email", v: "mc8620@mclink.it", href: "mailto:mc8620@mclink.it" },
          { k: "PEC", v: "carlo.traverso.ZKE7@sv.omceo.it", href: "mailto:carlo.traverso.ZKE7@sv.omceo.it" },
        ],
      },
    ],
  },
  {
    title: "Reclamo all'Autorità di controllo",
    blocks: [
      { p: "L'interessato ha diritto di proporre reclamo al Garante per la protezione dei dati personali qualora ritenga che il trattamento dei propri dati personali avvenga in violazione della normativa vigente." },
    ],
  },
  {
    title: "Processi decisionali automatizzati",
    blocks: [
      { p: "I dati raccolti attraverso il sito non sono sottoposti a processi decisionali automatizzati né a profilazione." },
    ],
  },
  {
    title: "Modifiche all'informativa",
    blocks: [
      { p: "La presente Privacy Policy potrà essere aggiornata in conseguenza di modifiche normative, tecniche od organizzative." },
      { p: "La versione aggiornata sarà pubblicata su questa pagina con indicazione della data dell'ultimo aggiornamento." },
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalDoc
      testid="privacy-policy-page"
      title="Privacy Policy"
      updated="16 settembre 2026"
      sections={SECTIONS}
    />
  );
}
